import {
  CONTACT_CHANNEL_TEXT,
  DONATION_FORM_TEXT,
  DONATION_STATUS,
  DONATION_STATUS_TEXT,
} from './constants';

export function pick(obj, keys, fallback = '') {
  if (!obj) return fallback;
  for (let i = 0; i < keys.length; i += 1) {
    const val = obj[keys[i]];
    if (val !== undefined && val !== null && val !== '') return val;
  }
  return fallback;
}

export function formatFen(fen) {
  const n = Number(fen);
  if (!Number.isFinite(n)) return '0.00';
  return (n / 100).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatYuan(fen) {
  return `${formatFen(fen)} 元`;
}

/** 原型金额：¥1,088,888.00 */
export function formatMoney(fen) {
  return `¥${formatFen(fen)}`;
}

export function formatCount(value) {
  if (value === undefined || value === null || value === '') return '--';
  const num = Number(value);
  if (!Number.isFinite(num)) return '--';
  return num.toLocaleString('zh-CN');
}

export function pickCount(obj, keys) {
  if (!obj) return undefined;
  for (let i = 0; i < keys.length; i += 1) {
    const val = obj[keys[i]];
    if (val !== undefined && val !== null && val !== '') return Number(val);
  }
  return undefined;
}

export function statusText(status) {
  const raw = Number(status);
  const view = raw === DONATION_STATUS.VOUCHER_REJECTED
    ? DONATION_STATUS.VOUCHER_REVIEW
    : raw;
  return DONATION_STATUS_TEXT[view] || '--';
}

export function formText(form) {
  return DONATION_FORM_TEXT[Number(form)] || '--';
}

export function channelText(channel) {
  return CONTACT_CHANNEL_TEXT[Number(channel)] || '--';
}

export function projectLabel(item) {
  if (!item) return '--';
  const name = pick(item, ['project_name']);
  const pid = pick(item, ['pid', 'project_id']);
  if (name && pid !== '') return `${name} [${pid}]`;
  return name || (pid !== '' ? `[${pid}]` : '--');
}

export function formatRemainSec(sec) {
  const n = Number(sec);
  if (!Number.isFinite(n) || n <= 0) return '已过期';
  const h = Math.floor(n / 3600);
  const m = Math.floor((n % 3600) / 60);
  const s = Math.floor(n % 60);
  if (h > 0) return `${h}小时${m}分${s}秒`;
  if (m > 0) return `${m}分${s}秒`;
  return `${s}秒`;
}

export function unwrapPayload(res) {
  if (!res) return {};
  if (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
    return res.data;
  }
  return res;
}

/**
 * Date → 本地时区 "YYYY-MM-DD"（TAPD 139053463）。
 * 不能用 toISOString().slice(0,10)，那是 UTC 日历，在东八区凌晨会退一天。
 */
export function formatLocalDateOnly(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * "YYYY-MM-DD" + days → "YYYY-MM-DD"（本地日历天）。TAPD 139053463
 * 用于后端未回传 fund_expire_date 时降级：donation_date + 365。
 */
export function addDaysToDateOnly(dateStr, days) {
  if (!dateStr || !/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return '';
  const [y, m, d] = dateStr.split('-').map(Number);
  const base = new Date(y, m - 1, d);
  if (Number.isNaN(base.getTime())) return '';
  base.setDate(base.getDate() + Number(days || 0));
  return formatLocalDateOnly(base);
}
